import { render, staticRenderFns } from "./BasketDetail.vue?vue&type=template&id=621dd257&scoped=true&"
import script from "./BasketDetail.vue?vue&type=script&lang=js&"
export * from "./BasketDetail.vue?vue&type=script&lang=js&"
import style0 from "./BasketDetail.vue?vue&type=style&index=0&id=621dd257&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621dd257",
  null
  
)

export default component.exports